import { render, staticRenderFns } from "./share_overlay.vue?vue&type=template&id=56e7b10c&scoped=true&"
import script from "./share_overlay.vue?vue&type=script&lang=js&"
export * from "./share_overlay.vue?vue&type=script&lang=js&"
import style0 from "./share_overlay.vue?vue&type=style&index=0&id=56e7b10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7b10c",
  null
  
)

export default component.exports